import React, { FC } from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import {
	BgUpload as BgUploadComponent,
	bgDocumentSlice,
	BgLimitRequestFull,
	getLimitUploadSetting,
} from 'Pages/ibro'
import { useAppDispatch } from 'Src/hooks'

interface ComponentProps {
	form: WrappedFormUtils
	item: BgLimitRequestFull
	fieldName: FieldNames
	requiredFields?: FieldNames[]
	withoutFileCash?: boolean
}

type ItemRequiredFields = Required<
	Pick<BgLimitRequestFull, 'id' | 'required_fields' | 'locked_fields'>
>

const actions = {
	saveDocument: bgDocumentSlice.actions.saveLimitRequestDocument,
	deleteDocument: bgDocumentSlice.actions.deleteLimitRequestDocument,
}
export const BgLimitRequestUpload: FC<ComponentProps> = ({
	fieldName,
	form,
	requiredFields,
	withoutFileCash,
	item,
}) => {
	const { saveDocument, deleteDocument } = useAppDispatch(actions)

	return (
		<BgUploadComponent
			item={item as ItemRequiredFields}
			form={form}
			fieldName={fieldName}
			requiredFields={requiredFields}
			saveDocument={saveDocument}
			deleteDocument={deleteDocument}
			withoutFileCash={withoutFileCash}
			initialValue={item[fieldName]}
			uploadSettings={getLimitUploadSetting(fieldName)}
		/>
	)
}
